import { CardWithC3CssProps } from './CssConfig';

export const interviewConfigs = [
  {
    componentReference: 'title',
    label: 'Interviews',
    id: 'interviews-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 7,
  },

  // cards
  {
    componentReference: 'container',
    id: 'interviews-cards-container',
    children: [
      {
        containerType: 'interviews',
        componentType: 'card',
        componentReference: 'card',
        id: 'interviews_completed',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'Completed Interviews',
          id: 'interviews',
          value: 40,
          topLabel: 'Completed Interviews',
          bottomLabel: 'INTERVIEWS',
        },
        api: {
          subject_type: 'interviews',
          metadata: {
            tileKey: 'interviews_completed',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'interviews_completed',
            id: 'interviews_completed',
          },
        },
      },
      {
        containerType: 'interviews',
        componentType: 'card',
        componentReference: 'card',
        id: 'applicants_interviewed',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'Completed Interviews',
          id: 'interviews',
          value: 22,
          topLabel: 'Interviewed applicants',
          bottomLabel: 'APPLICANTS',
        },
        api: {
          subject_type: 'interviews',
          metadata: {
            tileKey: 'applicants_interviewed',
            id: 'applicants_interviewed',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'applicants_interviewed',
          },
        },
      },
      {
        containerType: 'interviews',
        componentType: 'card',
        componentReference: 'card',
        id: 'time_spent_interviewing',
        selected: false,
        cssProps: CardWithC3CssProps,
        ui: {
          renderType: 'card',
          header: 'Completed Interviews',
          id: 'interviews',
          value: '27 Minutes',
          topLabel: 'Avg. time spent interviewing',
          bottomLabel: 'TIME',
        },
        api: {
          subject_type: 'interviews',
          metadata: {
            tileKey: 'time_spent_interviewing',
            id: 'time_spent_interviewing',
            componentType: 'card',
            calculationType: 'avgChange',
            apiParam: 'card',
            unit: 'time',
            metricKeys: {
              numerator: 'total_interview_duration',
              denominator: 'interviews_completed',
            },
          },
        },
      },
    ],
  },

  // interview trend
  {
    containerType: 'interviews',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'interviews_trend_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Completed interviews trend',
      id: 'interviews_trend_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [0, 0, 0, 27, 13],
      },
      chartType: 'area',
    },
    api: {
      subject_type: 'interviews',
      metadata: {
        tileKey: 'interviews_trend_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [],
        id: 'interviews_trend_chart',
      },
    },
  },

  // interview visual charts
  {
    componentReference: 'container',
    id: 'interviews-trend-chart-container-set1',
    children: [
      //visual chart 1
      {
        containerType: 'interviews',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'interviews_feedback_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Completed interviews by feedback',
          id: 'interviews_feedback_chart',
          chartData: {
            series: [
              {
                name: 'NO',
                y: 4,
              },
              {
                name: 'YES',
                y: 15,
              },
              {
                name: 'STRONG NO',
                y: 0,
              },
              {
                name: 'STRONG YES',
                y: 21,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'interviews',
          metadata: {
            tileKey: 'interviews_feedback_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'duration',
            },
            headerKeys: [],
            id: 'interviews_feedback_chart',
          },
        },
      },
      //visual chart 2
      {
        containerType: 'interviews',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'interviews_duration_chart',
        selected: false,
        cssProps: {
          width: '100%',
          display: 'block',
        },
        ui: {
          title: 'Completed interviews by duration',
          id: 'interviews_duration_chart',
          chartData: {
            series: [
              {
                name: '0-30 mins',
                y: 13,
              },
              {
                name: '30-60 mins',
                y: 25,
              },
              {
                name: '60-120 mins',
                y: 2,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'interviews',
          metadata: {
            tileKey: 'interviews_duration_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'duration',
            },
            headerKeys: [],
            id: 'interviews_duration_chart',
          },
        },
      },
    ],
  },

  // table
  {
    containerType: 'interviews',
    componentType: 'table',
    componentReference: 'table',
    id: 'interviews_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Interview breakdown',
      id: 'interviews_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          interviews_completed: 0,
          scorecards_filled: 0,
          time_to_fill_scorecard: 0,
          total_interview_duration: 0,
          applicants_interviewed: 0,
          total_scorecards: 10,
          total_scorecards_total: 50,
          pending_scorecards: 0,
          pending_scorecards_total: 0,
          strong_yes: 0,
          yes: 0,
          strong_no: 0,
          no: 0,
          interviews_completed_per: 0,
          interviews_completed_total: 40,
          strong_yes_total: 21,
          strong_yes_per: 0,
          strong_no_total: 0,
          strong_no_per: 0,
          yes_total: 15,
          yes_per: 0,
          no_total: 4,
          no_per: 0,
          applicants_interviewed_total: 24,
          applicants_interviewed_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          interviews_completed: 0,
          scorecards_filled: 0,
          time_to_fill_scorecard: 0,
          total_interview_duration: 0,
          applicants_interviewed: 0,
          total_scorecards: 10,
          pending_scorecards: 0,
          strong_yes: 0,
          yes: 0,
          strong_no: 0,
          no: 0,
          interviews_completed_per: 0,
          interviews_completed_total: 40,
          strong_yes_total: 21,
          strong_yes_per: 0,
          strong_no_total: 0,
          strong_no_per: 0,
          yes_total: 15,
          yes_per: 0,
          no_total: 4,
          no_per: 0,
          applicants_interviewed_total: 24,
          applicants_interviewed_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          interviews_completed: 0,
          scorecards_filled: 0,
          time_to_fill_scorecard: 0,
          total_interview_duration: 0,
          applicants_interviewed: 0,
          total_scorecards: 10,
          pending_scorecards: 0,
          strong_yes: 0,
          yes: 0,
          strong_no: 0,
          no: 0,
          interviews_completed_per: 0,
          interviews_completed_total: 40,
          strong_yes_total: 21,
          strong_yes_per: 0,
          strong_no_total: 0,
          strong_no_per: 0,
          yes_total: 15,
          yes_per: 0,
          no_total: 4,
          no_per: 0,
          applicants_interviewed_total: 24,
          applicants_interviewed_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          interviews_completed: 27,
          scorecards_filled: 27,
          time_to_fill_scorecard: 13608799,
          total_interview_duration: 45000,
          applicants_interviewed: 14,
          total_scorecards: 10,
          pending_scorecards: 0,
          strong_yes: 15,
          yes: 11,
          strong_no: 0,
          no: 1,
          interviews_completed_per: '67.5',
          interviews_completed_total: 40,
          strong_yes_total: 21,
          strong_yes_per: '71.4',
          strong_no_total: 0,
          strong_no_per: 0,
          yes_total: 15,
          yes_per: '73.3',
          no_total: 4,
          no_per: '25.0',
          applicants_interviewed_total: 24,
          applicants_interviewed_per: '58.3',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          interviews_completed: 13,
          scorecards_filled: 13,
          time_to_fill_scorecard: 2812672,
          total_interview_duration: 21600,
          applicants_interviewed: 10,
          total_scorecards: 10,
          pending_scorecards: 0,
          strong_yes: 6,
          yes: 4,
          strong_no: 0,
          no: 3,
          interviews_completed_per: '32.5',
          interviews_completed_total: 40,
          strong_yes_total: 21,
          strong_yes_per: '28.6',
          strong_no_total: 0,
          strong_no_per: 0,
          yes_total: 15,
          yes_per: '26.7',
          no_total: 4,
          no_per: '75.0',
          applicants_interviewed_total: 24,
          applicants_interviewed_per: '41.7',
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'interviews',
      metadata: {
        tileKey: 'interviews_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time', key: 'dt' },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'interviews_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'interviews_table',
      },
    },
  },
];

export const interviewsLayoutConfig = [
  {
    key: 'interviews_completed',
    x: 0,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'applicants_interviewed',
    x: 4,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'time_spent_interviewing',
    x: 8,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'interviews_trend_chart',
    x: 0,
    y: 7,
    w: 12,
    h: 21,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'interviews_feedback_chart',
    x: 6,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'interviews_duration_chart',
    x: 0,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'interviews_table',
    x: 0,
    y: 51,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
